var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrainingFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_training_face",
    transform: "translate(-396 -2171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_221",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 221",
    transform: "translate(-398.224 1997.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15",
    "data-name": "\\u6955\\u5186\\u5F62 15",
    transform: "translate(794.224 173.42)",
    fill: "#f5fafc",
    stroke: "#0071b9",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 45.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-generation-7",
    d: "M32.86,28.877a2.774,2.774,0,0,1-2.489,2.987,2.774,2.774,0,0,1-2.489-2.987,2.774,2.774,0,0,1,2.489-2.987A2.774,2.774,0,0,1,32.86,28.877ZM17.426,25.89a2.774,2.774,0,0,0-2.489,2.987,2.774,2.774,0,0,0,2.489,2.987,2.774,2.774,0,0,0,2.489-2.987A2.774,2.774,0,0,0,17.426,25.89ZM23.9,42.527c4.451,0,5.975-4.688,5.975-4.688H17.924S19.61,42.527,23.9,42.527ZM47.8,30.5a10.732,10.732,0,0,1-6.249,9.77C37.514,46.705,31.94,51.779,23.9,51.779c-7.62,0-13.616-5.074-17.649-11.513A10.736,10.736,0,0,1,0,30.5c0-4.089,1.717-7.568,5.4-7.894C7.094,4.481,22.464,5.857,24.988,1a4.533,4.533,0,0,1-.04,4.553c1.739-.09,4.668-2.6,5.487-5.082,1.5.729,2.057,3.141,1.306,4.688C32.82,4.949,36.1,2.864,37.839,0c1.37,3.113.052,7.1-1.41,9.5l-.024,0A20.684,20.684,0,0,1,42.4,22.6C46.1,22.928,47.8,26.417,47.8,30.5ZM42.658,26.78a1.522,1.522,0,0,0-1.338-.106,1.99,1.99,0,0,1-2.732-1.314l0,.032c-.663-5.186-2.24-9.667-5.2-11.083-12.8,13.959-21.548-1.82-23.779,7.028a20.579,20.579,0,0,0-.331,3.517,1.993,1.993,0,0,1-2.8,1.82,1.515,1.515,0,0,0-1.338.106c-1.992,1.3-1.78,8.333,3.095,9.981a1.99,1.99,0,0,1,1.065.856C14.172,45.689,19.7,47.8,23.9,47.8c6.548,0,11.182-4.519,14.6-10.179a2,2,0,0,1,1.065-.856C44.439,35.112,44.65,28.076,42.658,26.78Z",
    transform: "translate(419.135 2193.358)",
    fill: "#0071b9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrainingFace);
export default __webpack_public_path__ + "static/media/icon_training_face.c6b489bc903809d5cad0ac4fecd4543c.svg";
export { ForwardRef as ReactComponent };